<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'establishmentTypeCrud'"
          crudName="Tipos de Estabelecimentos"
          newText="Novo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="$hasAbility('cadastro.gerenciar')"
          :enableEdit="$hasAbility('cadastro.gerenciar')"
          :enableDelete="$hasAbility('cadastro.gerenciar')"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "establishmentTypeTable",
      showMessageImport: false,
      establishmentTypeCrud: {},
      pages: [],
      url: "",
      columns: ["id", "establishment_type_name", "status", "actions"],
      tableData: ["id", "establishment_type_name", "status"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "establishment_type_name", "status"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          establishment_type_name: "Nome",
          status: "Status",
          actions: "Ações",
        },
        sortable: ["id", "establishment_type_name", "status"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: "Ativo",
            },
            {
              id: 0,
              text: "Inativo",
            },
          ],
        },
        templates: {
          status: function (h, row, index) {
            return row.status == 1
              ? "Ativo"
              : row.status == 0
              ? "Inativo"
              : "Inativo";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "establishment_types",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        id: "id",
        establishment_type_name: "establishment_type_name",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>